import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BASE}/api`;
export const SITE_ORIGIN = typeof window !== "undefined" ? window.location.origin : BASE;

const client = axios.create({ baseURL: API_BASE, timeout: 20000 });

// Attach admin JWT when present
client.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("caf_admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const api = {
  get: (path, params) => client.get(path, { params }).then((r) => r.data),
  post: (path, body) => client.post(path, body).then((r) => r.data),
  put: (path, body) => client.put(path, body).then((r) => r.data),
  del: (path) => client.delete(path).then((r) => r.data),
};

export const adminAuth = {
  token: () => localStorage.getItem("caf_admin_token"),
  set: (t) => localStorage.setItem("caf_admin_token", t),
  clear: () => localStorage.removeItem("caf_admin_token"),
  isLoggedIn: () => !!localStorage.getItem("caf_admin_token"),
};

export const endpoints = {
  volunteers: "/volunteers",
  donations: "/donations",
  issues: "/issue-reports",
  newsletter: "/newsletter",
  contact: "/contact",
  csr: "/csr-inquiries",
  posts: "/posts",
  campaigns: "/campaigns",
  testimonials: "/testimonials",
  team: "/team",
  faqs: "/faqs",
  gallery: "/gallery",
  successStories: "/success-stories",
  programs: "/programs",
  stats: "/stats",
  // Phase 4
  login: "/auth/login",
  me: "/auth/me",
  paymentsConfig: "/payments/config",
  paymentsOrder: "/payments/order",
  paymentsVerify: "/payments/verify",
  donorWall: "/donor-wall",
  receipts: (id) => `/receipts/${id}`,
  seoSettings: "/settings/seo",
  siteSettings: "/settings/site",
  adminCampaigns: "/admin/campaigns",
  adminPosts: "/admin/posts",
};
